<label>{{labelName}}</label>
<div #DdStates class="ui selection dropdown multiple" [class.search]="search" >
  <input name="state" type="hidden">
  <i class="dropdown icon"></i>
  <div class="default text">{{defaultText}}</div>
  <div class="menu">
    <div class="item" *ngFor="let elem of collection; let i = index;" [attr.data-index]="i" [attr.data-value]="resolveValue(elem)" >{{resolveName(elem)}}</div>
  </div>
</div>
